
import { availableFormItems, availableTableItems } from './config/availableItems';
import { MODULE_TYPE } from './config/moduleType';
import { config as CONFIG, PubSub } from '@platform/api';

/**
 * 我们要生成的数据格式
 *
 * @keyByModuleId = {
 *     moduleId1: {
 *         firstItem: 'attrCode1',
 *         lastItem: 'attrCode2',
 *         type: 'form'
 *     },
 *     moduleId2: {
 *         firstItem: 'attrCode3',
 *         lastItem: 'attrCode4',
 *         type: 'table',
 *         children: ['moduleId3', 'moduleId4'] // 表示此表格的关联表有哪些
 *     },
 *     moduleId3: {
 *         firstItem: 'attrCode3',
 *         lastItem: 'attrCode4',
 *         type: 'table',
 *         parent: 'moduleId3', // 表示此表格的主表是哪个，
 *         activeTable: 'moduleId3' //对于多页签的表格添加此字段表示当显示的是哪个页签，第一次渲染默认展示主
 *                                    表
 *     }
 * }
 *
 * @formDisableAttrCode = {
 *     moduleId: {
 *         attrCode1: true,
 *         attrCode2: false
 *     }
 * }
 */
let keyByModuleId = window.keyByModuleId = {};
let formDisableAttrCode = window.formDisableAttrCode = {};
let tableDisabledAttrCode = window.tableDisabledAttrCode = {};
let orderOfHotKey = window.orderOfHotKey || [];
const hotKeyPrefix = CONFIG.hotKeyModuleIdPrefix;

/**
 * @desc 实现上面所描述的数据格式
 * @param props
 * @param force 是否强制执行，如果是通过业务组调用executeAutoFocus方法执行，就强制执行聚焦方法， 默认false
 */
function keyMapOfForm(props, force = false) {
    let { name } = props;
    let { meta, orderOfHotKey: newOrderOfHotKey } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};

    // 可以考虑加个参数控制整个快捷键  TOOD
    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }

    let formItems = meta[name]['items'];
    orderOfHotKey = newOrderOfHotKey;

    let itemsAttrCode = formItems.filter(item => {
        return isAvailableFormItem(item, name);
    }).map(item => {
        return item.attrcode;
    });

    if (formAutoFocusJudgement(name, force)) {
        keyByModuleId[name] = {
            firstItem: itemsAttrCode[0],
            type: MODULE_TYPE.form,
        };
        let firstItemKey = itemsAttrCode[0];
        PubSub.publish('autoFocus', { data: firstItemKey });
    }
}

/**
 * @desc：keyMapOfForm方法会根据form的状态执行多次。
 * 现象：只要meta里面的数据一更改就会重新聚焦到第一个可编辑元素上。
 * 解决：keyByModuleId里是否存在此moduleId作为标示，
 */
function formAutoFocusJudgement(name, force) {
    return (keyByModuleId[name] === undefined && orderOfHotKey[0] === name) || force;
}

/**
 * @desc 判断此item是否需要在按tab键获得焦点
 * @param item
 * @param name
 * @returns {boolean}
 */
function isAvailableFormItem(item, name) {
    let metaRes = availableFormItems.includes(item.itemtype) &&
        item.disabled !== true &&
        item.visible !== false;

    let itemDisabled = !!(formDisableAttrCode[name] &&
        formDisableAttrCode[name][item.attrcode] === true);
    return metaRes && !itemDisabled;
}

/**
 *
 * @param props
 * @param force {Boolean} 是否强制执行
 */
function keyMapOfTable(props, force = false) {
    let { name, high_hotkey, getHotKeyConfig } = props;

    // console.log(high_hotkey, getHotKeyConfig)
    let { withHotKeyChange, meta, orderOfHotKey: newOrderOfHotKey } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};
    if (!props.getHotKeyConfig || !newOrderOfHotKey) {
        return console.warn('some form hotkey invalid');
    }
    orderOfHotKey = newOrderOfHotKey;
    let { store, tableId } = high_hotkey;

    let columns = meta[tableId] && meta[tableId].items;
    let rows = store.getData();
    let lastRowIndex = rows.length - 1;
    let availableItems = columns && iteratorTableColumns(tableId, columns, []);

    if (rows && rows.length === 0) return;
    processKeyMapOfTable({ moduleId: tableId, availableItems, lastRowIndex, moduleType: MODULE_TYPE.cardTable, force });
    if (hasTabRelation(props, tableId) && keyByModuleId[tableId]) {
        createTabRelationKeyMap(props, tableId, lastRowIndex);
        //设置关联表
        keyByModuleId[tableId].children = meta.gridrelation[tableId].tabRelation;
    }
}

function keyMapOfEditTable(props, force = false) {
    let { name, high_hotkey, getHotKeyConfig } = props;
    // console.log(high_hotkey, getHotKeyConfig)
    let { withHotKeyChange, meta, orderOfHotKey: newOrderOfHotKey } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};
    if (!props.getHotKeyConfig || !newOrderOfHotKey) {
        return console.warn('some form hotkey invalid');
    }
    orderOfHotKey = newOrderOfHotKey;
    let { store, tableId } = high_hotkey;

    let columns = meta[tableId] && meta[tableId].items;
    let rows = store.getData();
    let lastRowIndex = rows.length - 1;
    let availableItems = columns && iteratorTableColumns(tableId, columns, []);

    if (rows && rows.length === 0) return;

    processKeyMapOfTable({ tableId, availableItems, lastRowIndex, moduleType: MODULE_TYPE.editTable, force });
}

function iteratorTableColumns(tableId, iterable, pool) {
    return iterable.reduce((pre, next) => {
        if (next.children) {
            iteratorTableColumns(tableId, next.children, pre);
        } else {
            isAvailableTableItem(tableId, next)
                ? pre.push(next.attrcode)
                : pre;
        }

        return pre;
    }, pool);
}

function isAvailableTableItem(moduleId, item) {
    //如果业务组通过table的api修改可编辑性，就根据业务组的设置的只返回，不去读meta里面的值
    if (tableDisabledAttrCode[moduleId]) {
        if (tableDisabledAttrCode[moduleId][item.attrcode] === false) {
            return false;
        }

        if (tableDisabledAttrCode[moduleId][item.attrcode] === true) {
            return true;
        }
    }

    return availableTableItems.includes(item.itemtype) &&
        item.visible !== false &&
        item.disabled !== true &&
        item.attrcode !== undefined;
}

function processKeyMapOfTable({ moduleId, availableItems, lastRowIndex, moduleType, force }) {
    let firstItem = `${hotKeyPrefix}-${moduleId}-${availableItems[0]}-0`;
    let lastAvailableItem = availableItems.length - 1;
    let lastItem = `${hotKeyPrefix}-${moduleId}-${availableItems[lastAvailableItem]}-${lastRowIndex}`;

    publishFocusItem({ orderOfHotKey, moduleId, firstItem, force });

    keyByModuleId[moduleId] = {
        firstItem,
        lastItem,
        type: moduleType,
        activeTable: moduleId,
    };
}

/**
 * @desc    原因：此方法是在componentDidUpdate生命周期里调用的。
 *          现象：只要meta里面的数据一更改就会重新聚焦到第一个可编辑元素上。
 *          解决：keyByModuleId里是否存在此moduleId作为标示
 *
 * @param orderOfHotKey
 * @param moduleId
 * @param firstItem
 * @param force 是否强制执行，如果是业务组通过executeAutoFocus api 执行的，就强制执行
 */
function publishFocusItem({ orderOfHotKey, moduleId, firstItem, force }) {
    if (tableAutoFocusJudgement({ orderOfHotKey, moduleId, force })) {
        PubSub.publish('autoFocus', { data: firstItem, moduleId });
    }
}

function tableAutoFocusJudgement({ orderOfHotKey = [], moduleId, force }) {
    return (orderOfHotKey[0] === moduleId && keyByModuleId[moduleId] === undefined) || force;
}

/**
 * @desc 判断此table是否有tabRelation
 * @param props {object}
 * @param moduleId {string}
 */

function hasTabRelation(props, moduleId) {
    // console.log(high_hotkey, getHotKeyConfig)
    let { meta } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};
    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }

    let tabRelation = meta.gridrelation &&
        meta.gridrelation[moduleId].tabRelation;

    return !!(tabRelation && tabRelation.length > 1);
}

function createTabRelationKeyMap(props, moduleId, lastRowIndex) {
    let { meta } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};
    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }

    let tabRelation = meta.gridrelation[moduleId].tabRelation;

    tabRelation.forEach(item => {
        //因为主表keyMap已经生成不需要重复执行
        if (item !== moduleId) {
            let columns = meta[item] &&
                meta[item].items;
            let availableItems = columns && iteratorTableColumns(moduleId, columns, []);
            let code = meta[item].code;

            let firstItem = `${hotKeyPrefix}-${moduleId}-${availableItems[0]}-0`;
            let lastAvailableItem = availableItems[availableItems.length - 1];

            let lastItem = `${hotKeyPrefix}-${moduleId}-${lastAvailableItem}-${lastRowIndex}`;
            /**
             * @type {{parent: string}} 表明此此标签页属于哪个区域ID
             */
            keyByModuleId[code] = {
                firstItem,
                lastItem,
                type: MODULE_TYPE.cardTable,
                parent: moduleId,
            };
        }
    });
}

function deleteKeyByModuleId(moduleId) {
    delete keyByModuleId[moduleId];
}

function setFormDisableAttrCode(moduleId, values) {
    formDisableAttrCode[moduleId] = values;
}

/**
 *
 * @param disabledValue {boolean} 是否可编辑 true -> 可编辑 false -> 不可编辑
 * @param moduleId  {string}
 * @param attrcode {string}
 */
function editTableFieldEditable(disabledValue, moduleId, attrcode) {
    if (tableDisabledAttrCode[moduleId] === undefined) {
        tableDisabledAttrCode[moduleId] = { [attrcode]: disabledValue };
    } else {
        tableDisabledAttrCode[moduleId][attrcode] = disabledValue;
    }
}

function getFirstItem(moduleId) {
    return keyByModuleId[moduleId] &&
        keyByModuleId[moduleId].firstItem;
}

function setValueOfActiveTable({ moduleId, activeKey }) {
    let moduleInfo = keyByModuleId[moduleId];
    if (moduleInfo) {
        moduleInfo.activeTable = activeKey;
    }
}

let createByModuleType = {
    form: keyMapOfForm,
    table: keyMapOfTable,
    editTable: keyMapOfEditTable,
};

export {
    createByModuleType,
    keyByModuleId,
    orderOfHotKey,
    deleteKeyByModuleId,
    setFormDisableAttrCode,
    editTableFieldEditable,
    getFirstItem,
    setValueOfActiveTable,
};